
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-end pb-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0F172A] via-[#1E1B4B] to-[#312E81]"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-1/4 right-1/4 w-64 h-64 bg-cyan-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/3 right-1/3 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 w-2 h-2 bg-cyan-400 rounded-full"></div>
      <div className="absolute top-1/3 right-1/4 w-1 h-1 bg-purple-400 rounded-full"></div>
      <div className="absolute bottom-1/2 right-1/2 w-1 h-1 bg-cyan-300 rounded-full"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-3xl">
          <div className="inline-block px-4 py-2 border border-cyan-400/50 rounded-full mb-8">
            <span className="text-cyan-300 text-xs uppercase tracking-wider font-light">iOS Development Experts</span>
          </div>
          <h1 className="text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
            Modern Applications<br />
            For iOS Platform
          </h1>
          <p className="text-gray-300 text-lg leading-relaxed max-w-2xl">
            A team of experts developing cutting-edge applications that enhance user experience and improve the security of mobile devices.
          </p>
        </div>
      </div>
    </section>
  );
}
